import styled from "styled-components"
import { themeGet } from "styled-system"
import { Col, Container, Form, Row } from "react-bootstrap"
import { Tooltip } from "./utils/style"

export const StyledParagraph = styled.p`
    margin: 5px;
    list-style: none;
      position: relative;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    cursor:pointer;
    background-color: #dffffb;
    color: #3e3c46;
    font-family:Trebuchet MS;
    font-size:17px;
    font-weight:100;
    border-radius: 2px;
    padding: 0px 13px 0px 13px
    &:hover {
      ${Tooltip} {
        opacity: 1;
        visibility: visible;
        bottom: calc(100% + 5px);
      }
`

export const StyledCol = styled(Col)`
padding: 5px

@media (max-width: 600px) {
  margin: 0 
}
`

export const StyledDiv = styled.div`
margin-top: 10px
`

export const StyledContainer = styled(Container)`
display:flex;
align-items: center;
justify-content: center;
`


export const StyledIcon = styled.i`
color: ${themeGet("colors.hvitisBlue")};
font-size: 60px;
margin: 10px 0px 0px 0px
`
export const StyledOption = styled.option`

`
export const StyledSelect = styled(Form.Control)`
font-size: 25px
background-color: white
border-color: white
margin:8px
`

export const StyledInput = styled(Form.File.Input)`
      box-shadow: 2px 3px 3px 0px #1564ad;
      background: linear-gradient(to bottom, #79bbff 5%, #378de5 100%);
      background-color: #79bbff;
      border-radius: 10px;
      border: 1px solid #337bc4;
      cursor: pointer;
      color: #ffffff;
      font-family: Trebuchet MS;
      font-size: 21px;
      font-weight: bold;
      text-decoration: none;
      text-shadow: 0px 1px 5px #528ecc;
      margin: 8px;
    `

export const BlogPostsWrapper = styled.div`
  margin: 0 auto;
  padding: 90px 0 0 0;
  position: relative;
  max-width: 1170px;
  width: 100%;
x
  @media (max-width: 1440px) {
    max-width: 990px;
  }
  @media (max-width: 1400px) {
    padding: 90px 0 0 0;
  }
  @media (max-width: 1199px) {
    padding: 90px 45px 0 45px;
    max-width: 890px;
  }
  @media (max-width: 990px) {
    padding: 50px 25px 0 25px;
  }
  .pagination {
    margin-top: 80px;
    @media (max-width: 1024px) {
      margin-top: 60px;
    }
    @media (max-width: 575px) {
      margin-top: 30px;
    }
  }
`

export const SecTitle = styled.div`
  color: ${themeGet("colors.textColor", "#292929")};
  font-size: 16px;
  font-weight: 500;
  font-family: ${themeGet("fontFamily.0", "'Fira Sans',sans-serif")};
  letter-spacing: 0.17em;
  position: relative;
  margin-bottom: 30px;

  &:after {
    content: "";
    width: 68px;
    height: 1px;
    background: #292929;
    display: block;
    margin-top: 8px;
  }
`
export const LegoForm = styled.form`

input {
  margin: 8px;
  font-size: 21px;
  font-weight: normal;
  color: ${themeGet("colors.textColor", "#292929")};
  font-weight: bold; */
  width: 80%;
  font-size: 25px;
  /* font-weight: normal; */
  color: #0c1727;
  border: dashed 2px cornflowerblue;
  background: #edf2ff9c;
  border-radius: 8px;
  &:focus {
    outline: none;
  }
  @media (max-width: 990px) {
    width: 100%;
  }

}
`
export const LEGORow = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
    
`
export const FlexAlignCenter = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
`
export const PostCol = styled.div`
    display: flex;
    margin-top: 10px;

    @media (max-width: 1024px) {
      padding: 0 10px;
      margin-bottom: 20px;
    }
    @media (max-width: 825px) {
      align-items: center;
      justify-content: center;
      flex-flow: column wrap;
      align-content: flex-center;
      width: 100%;
      margin-top: 50px;
    }
    @media (max-width: 575px) {

    }
`
export const DangerAlert = styled.p`
    margin: 20px;
    width: 80%;
    margin-top: 10px;
    font-size: 13px !important;
    font-weight: 300 !important;
    font-weight: bold;
    font-size: 15px;
    color: #860814c7;
    border: solid 2px #c72b48ad;
    background: #ffedef9c;
    padding: 14px;
    border-radius: 8px;
`
export const DangerMark = styled.mark`
    background-color: #ff8585;
    color: white;
    font-weight: bold;
    border-radius: 4px;
    padding: 3px 8px 3px 8px;
`
export const SuccessAlert = styled.p`
    margin: 20px;
    width: 80%;
    margin-top: 10px;
    font-size: 13px !important;
    font-weight: 300 !important;
    font-weight: bold;
    font-size: 15px;
    color: #272d22;
    border: solid 2px #0EE49F;
    background: #effff4;
    padding: 14px;
    border-radius: 8px;
`
export const SuccessMark = styled.mark`
    background-color: #6ff7b3;
    color: white;
    font-weight: bold;
    border-radius: 4px;
    padding: 3px 8px 3px 8px;
`
export const AlwaysOnInfoAlert = styled.p`
    width: 80%;
    font-size: 13px !important;
    font-weight: 300 !important;
    font-weight: bold;
    font-size: 15px;
    color: #021840eb;
    border: solid 2px #49a4d0a8;
    background: #edfcff9c;
    padding: 14px;
    border-radius: 8px;
    height: 0px;
    height: auto;
    margin: 20px;
    margin-bottom: 10px;
`

export const InfoAlert = styled.p`
    width: 80%;
    font-size: 13px !important;
    font-weight: 300 !important;
    font-weight: bold;
    font-size: 15px;
    color: #021840eb;
    border: solid 2px #49a4d0a8;
    background: #edfcff9c;
    padding: 14px;
    border-radius: 8px;
    height: 0px;
    margin: 0px;
    visibility:hidden;  
    @media (max-width: 990px) {
      visibility:visible;
      height: auto;
      margin: 20px;
      margin-bottom: 10px;
    }
    @media (max-width: 575px) {
      visibility:visible;
      height: auto;
    }
`
export const InfoMark = styled.mark`
    background-color: #67a4f1ed;
    color: white;
    font-weight: bold;
    border-radius: 4px;
    padding: 3px 8px 3px 8px;
`

export const StyledButton = styled.button`
    box-shadow: 2px 3px 3px 0px #1564ad;
    background:linear-gradient(to bottom, #79bbff 5%, #378de5 100%);
    background-color:#79bbff;
    border-radius:10px;
    border:1px solid #337bc4;
    display:inline-block;
    cursor:pointer;
    color:#ffffff;
    font-family:Trebuchet MS;
    font-size:21px;
    font-weight:bold;
    padding:12px 44px;
    text-decoration:none;
    text-shadow:0px 1px 5px #528ecc;
    margin: 20px;

`


export const DownloadButton = styled.button`
    box-shadow: 2px 3px 3px 0px ${themeGet("hvitisBlueDark")};
    background:linear-gradient(to bottom, ${themeGet("hvitisBlue")}; 5%, ${themeGet("hvitisBlueDark")} 100%);
    background-color:#79bbff;
    border-radius:20px;
    border:1px solid #337bc4;
    display:inline-block;
    cursor:pointer;
    color:#ffffff;
    font-family:Trebuchet MS;
    font-size:15px;
    font-weight:300;
    padding:6px 20px;
    text-decoration:none;
    text-shadow:0px 1px 5px #528ecc;
    margin: 5px;

`

export const GenerateButton = styled.button`
    box-shadow: 2px 3px 3px 0px #10e69f;
    background:linear-gradient(to bottom, #0ca39e 5%, #10e69f 100%);
    background-color:#7ee5ef;
    border-radius:10px;
    border:1px solid #087f70;
    display:inline-block;
    cursor:pointer;
    color:#ffffff;
    font-family:Trebuchet MS;
    font-size:21px;
    font-weight:bold;
    padding:12px 44px;
    text-decoration:none;
    text-shadow:0px 1px 5px #087f70;
    margin: 8px;
    visibility:visible;  
`

export const LoadMoreButton = styled.div`
  text-align: center;
  margin-top: 70px;
  @media (max-width: 990px) {
    margin-top: 50px;
  }
  @media (max-width: 575px) {
    margin-top: 30px;
  }
`


export default BlogPostsWrapper
